<template>
  <section class="section">
    <BaseForm
      ref="baseForm"
      :title="$t('models.auth.changeEmail')"
      :data-object="changeEmailVerification"
      :content-type="'user'"
      :custom-submit="true"
      :on-custom-submit="verifyChangeEmail"
      :column-width="'is-6 is-offset-2'"
    >
      <template #content>
        <v-text-field
          v-model.trim="props.email"
          :label="$t('models.auth.newEMail')"
          disabled
          type="email"
          class="field"
          name="email"
          value=""
          required
        />
        <v-text-field
          v-model.trim="changeEmailVerification.pin"
          :label="$t('models.auth.pinFromEmail')"
          class="field"
          name="pin"
          value=""
          required
        />
      </template>
    </BaseForm>
  </section>
</template>

<script setup lang="ts">
import { onMounted, Ref, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useSnackbar } from 'vuetify-use-dialog'
import { useStore } from 'vuex'

import { apiClient } from '@/api/ApiClient'
import BaseForm from '@/components/common/BaseForm.vue'
import { EmailUpdate } from '@/models/core/models'
const createSnackbar = useSnackbar()

const store = useStore()
const router = useRouter()
const props = defineProps({
  id: {
    default: '',
  },
  email: {
    default: '',
  },
  nonce: {
    default: '',
  },
})
const changeEmailVerification: Ref<EmailUpdate> = ref({
  nonce: props.nonce,
  pin: '',
})
const baseForm: Ref<typeof BaseForm> = ref(null)

onMounted(() => {
  // If the nonce is empty (e.g. after refreshing page) we can not retrieve it and the process needs to start again
  if (props.nonce === '' || props.id !== store.state.global.profileId) {
    router.push({ name: 'profile-list' })
  }
})

function verifyChangeEmail() {
  apiClient
    .updateEmail(props.id, changeEmailVerification.value)
    .then((response) => {
      createSnackbar({
        text: 'Successfully changed E-Mail!',
        snackbarProps: { color: 'green-darken-3' },
      })
      router.push({ name: 'profile-list' })
    })
    .catch((error) => {
      baseForm.value.handleError(error)
    })
}
</script>

<style></style>
